// extracted by mini-css-extract-plugin
export default {"image":"ProductImage_image__0ygLz"};